import styled from "styled-components";

export default styled.div`
  
  height: 300px;
  width: 100%;
  margin:15px;   
  background-color: #FFDB4510;`